import { render, staticRenderFns } from "./BaseData.vue?vue&type=template&id=1477b8ec&scoped=true&"
import script from "./BaseData.vue?vue&type=script&lang=js&"
export * from "./BaseData.vue?vue&type=script&lang=js&"
import style0 from "./BaseData.vue?vue&type=style&index=0&id=1477b8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1477b8ec",
  null
  
)

export default component.exports